var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "my-shop-nav"
  }, [_c('div', {
    staticClass: "btn home",
    class: {
      active: _vm.inMyShop
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toPromoteProduct();
      }
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "btn order",
    class: {
      active: _vm.inOrderList
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toOrderList();
      }
    }
  }, [_vm._m(1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-cont"
  }, [_c('div', {
    staticClass: "btn-icon"
  }), _c('span', {
    staticClass: "btn-name"
  }, [_vm._v("首页")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btn-cont"
  }, [_c('div', {
    staticClass: "btn-icon"
  }), _c('span', {
    staticClass: "btn-name"
  }, [_vm._v("我的订单")])]);
}];
export { render, staticRenderFns };